import { useCountryContext } from '@archipro-website/localisation';
import { HeroSection } from './sections/HeroSection';
import { IntroSection } from './sections/IntroSection';
import { FeatureStripSection } from './sections/FeatureStripSection';
import { UsLaunchBannerSection } from './sections/UsLaunchBannerSection';
import { DiscoverProjectsSection } from './sections/DiscoverProjectsSection';
import { DiscoverProfessionalsSection } from './sections/DiscoverProfessionalsSection';
import { ProductsSection } from './sections/ProductsSection';
import { ArticlesSection } from './sections/ArticlesSection';
import { MagazineSection } from './sections/MagazineSection';
import { SectionSpacer } from './components/SectionSpacer';
import { ScrollReveal } from './components/ScrollReveal';

/**
 * New logged-out homepage (BC-4442). Sections are added top-to-bottom as they
 * are built; each reads what it needs from the `_app._index` loader. The old
 * `HomePage*` components are removed at cutover once every section has landed.
 */
export const HomePage = () => {
    // The "Coming to America" launch banner is US-only; NZ/AU skip the section.
    const isUS = useCountryContext().byCountry({
        US: true,
        AU: false,
        NZ: false,
    });

    return (
        <>
            <HeroSection />
            <SectionSpacer
                height={197}
                mobileHeight={59}
                className="bg-white"
            />
            <ScrollReveal>
                <IntroSection />
            </ScrollReveal>
            <SectionSpacer
                height={160}
                mobileHeight={59}
                className="bg-white"
            />
            <ScrollReveal>
                <FeatureStripSection />
            </ScrollReveal>
            {isUS && (
                <>
                    <SectionSpacer
                        height={0}
                        mobileHeight={59}
                        className="bg-white"
                    />
                    <ScrollReveal>
                        <UsLaunchBannerSection />
                    </ScrollReveal>
                </>
            )}
            {/* These sections stagger their own header/cards reveals internally. */}
            <DiscoverProjectsSection />
            <DiscoverProfessionalsSection />
            <ProductsSection />
            <ArticlesSection />
            <MagazineSection />
        </>
    );
};
